/**
 * Семантика фильтра отделов Ганта:
 * - null = все отделы
 * - Set (в т.ч. пустой) = явный выбор; пустой Set = ничего не показывать
 */

/** @param {null|Set<string>|undefined} selected */
export function isAllDepartments(selected) {
  return selected == null;
}

/** @param {null|Set<string>|undefined} selected @param {string} key */
export function isDepartmentChecked(selected, key) {
  if (isAllDepartments(selected)) return true;
  return selected.has(key);
}

/**
 * @param {null|Set<string>} selected
 * @param {string[]} allKeys
 * @param {string} key
 * @returns {null|Set<string>}
 */
export function toggleDepartmentSelection(selected, allKeys, key) {
  let next;
  if (isAllDepartments(selected)) {
    next = new Set(allKeys.filter((k) => k !== key));
  } else {
    next = new Set(selected);
    if (next.has(key)) next.delete(key);
    else next.add(key);
  }
  return next.size === allKeys.length ? null : next;
}

/** @param {null|Set<string>|undefined} selected @param {string} scheduleType */
export function passesDepartmentFilter(selected, scheduleType) {
  return isAllDepartments(selected) || selected.has(scheduleType);
}

export function selectAllDepartments() {
  return null;
}

export function clearDepartments() {
  return new Set();
}

/** @param {null|Set<string>|undefined} selected */
export function departmentFilterLabel(selected, pluralFn) {
  if (isAllDepartments(selected)) return 'Все отделы';
  const n = selected.size;
  if (n === 0) return '0 отделов';
  return `${n} ${pluralFn(n)}`;
}
